import { gql } from "@apollo/client";

export default gql`
  query routineMeetingGroups($organizationId: Int!, $search: String) {
    meetingGroups(organizationId: $organizationId, search: $search, first: 50) {
      edges {
        node {
          id
          title
          isFormalOneonone
          recurrenceRule
        }
      }
    }
  }
`;
